import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "text-red-500 m-3" }, "Oops ... We could not find this!", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PButton = _resolveComponent("PButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_PButton, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navigateTo('/'))),
      label: "Go to dashboard",
      text: ""
    })
  ], 64))
}